export default "__VITE_ASSET__Dw28MDoP__"